/**
 * Copy for the multi-zone quick-run picker.
 *
 * Both lines have to say the same thing about ORDER: Rachio runs a batch one
 * zone after another, so "3 zones, 10 minutes each" is half an hour of
 * watering, not ten minutes of it. Getting that wrong is how someone starts a
 * batch at dusk expecting it to be done by dark.
 *
 * Pure so it can be tested without a DOM; the modal only renders what it
 * returns.
 */

import { fmtMinutes } from './format.js';

/** Total valve time a batch will take: they run in sequence, never together. */
export function batchTotalMinutes(zoneCount: number, minutesEach: number): number {
  return zoneCount * minutesEach;
}

/**
 * The line under the zone list, e.g. `3 zones · 30 min total · runs one after
 * another`. The sequencing clause is dropped for a single zone, where there is
 * nothing to be after.
 */
export function batchSummary(zoneCount: number, minutesEach: number): string {
  const zones = `${zoneCount} ${zoneCount === 1 ? 'zone' : 'zones'}`;
  const total = `${fmtMinutes(batchTotalMinutes(zoneCount, minutesEach))} total`;
  return zoneCount > 1 ? `${zones} · ${total} · runs one after another` : `${zones} · ${total}`;
}

/** The success toast, e.g. `Running Front, Back, Side (30 min total).` */
export function batchToast(zoneNames: string[], minutesEach: number): string {
  const total = fmtMinutes(batchTotalMinutes(zoneNames.length, minutesEach));
  return `Running ${zoneNames.join(', ')} (${total} total).`;
}
